"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _tag = _interopRequireDefault(require("../chord_sheet/tag"));

var _chord_lyrics_pair = _interopRequireDefault(require("../chord_sheet/chord_lyrics_pair"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var NEW_LINE = '\n';
/**
 * Formats a song into a ChordPro chord sheet
 */

var ChordProFormatter = /*#__PURE__*/function () {
  function ChordProFormatter() {
    _classCallCheck(this, ChordProFormatter);
  }

  _createClass(ChordProFormatter, [{
    key: "format",

    /**
     * Formats a song into a ChordPro chord sheet.
     * @param {Song} song The song to be formatted
     * @returns {string} The ChordPro string
     */
    value: function format(song) {
      var _this = this;

      return song.lines.map(function (line) {
        return _this.formatLine(line);
      }).join(NEW_LINE);
    }
  }, {
    key: "formatLine",
    value: function formatLine(line) {
      var _this2 = this;

      return line.items.map(function (item) {
        return _this2.formatItem(item);
      }).join('');
    }
  }, {
    key: "formatItem",
    value: function formatItem(item) {
      if (item instanceof _tag["default"]) {
        return this.formatTag(item);
      } else if (item instanceof _chord_lyrics_pair["default"]) {
        return this.formatChordLyricsPair(item);
      }

      return '';
    }
  }, {
    key: "formatTag",
    value: function formatTag(tag) {
      if (tag.hasValue()) {
        return "{".concat(tag.originalName, ": ").concat(tag.value, "}");
      }

      return "{".concat(tag.originalName, "}");
    }
  }, {
    key: "formatChordLyricsPair",
    value: function formatChordLyricsPair(chordLyricsPair) {
      return [this.formatChordLyricsPairChords(chordLyricsPair), this.formatChordLyricsPairLyrics(chordLyricsPair)].join('');
    }
  }, {
    key: "formatChordLyricsPairChords",
    value: function formatChordLyricsPairChords(chordLyricsPair) {
      if (chordLyricsPair.chords) {
        return "[".concat(chordLyricsPair.chords, "]");
      }

      return '';
    }
  }, {
    key: "formatChordLyricsPairLyrics",
    value: function formatChordLyricsPairLyrics(chordLyricsPair) {
      return chordLyricsPair.lyrics || '';
    }
  }]);

  return ChordProFormatter;
}();

var _default = ChordProFormatter;
exports["default"] = _default;